//@ helpers
const actionTypes = require('constants/contactCenter/actionTypes');
// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
//@ actions
const signaturePatternActions = require('actions/signaturePattern');
//@ constants
const {FIRST_STEP, DEPOSIT_HIRE_CONFIRMATION_CHANNEL} = require('constants/index');
const { API_ENTERPRISE_NUMBER, API_CENTER } = require('constants/index');

const reset = () => ({
    type: actionTypes.ADD_DEPOSIT_IMPOSITION_RESET
});

const setVisibleStep = (data) => ({
    type: actionTypes.ADD_DEPOSIT_IMPOSITION_SET_VISIBLE_STEP,
    payload: {
        data
    }
});

const setImpositionValue = depositValue => ({
    type: actionTypes.ADD_DEPOSIT_IMPOSITION_SET_CURRENT_VALUE,
    payload: {
        depositValue
    }
});

const validateUIStep = (depositsData) => ({
    type: actionTypes.ADD_DEPOSIT_IMPOSITION_VALIDATE_STEP,
    payload: {
        depositsData
    }
});


const setCurrentDepositImposition = depositValue => (dispatch, getState) => {
    const depositsData = getState().depositsDetails;

    dispatch(setImpositionValue(depositValue));
    dispatch(validateUIStep(depositsData));
}

const setWillCancel = willCancel => ({
    type: actionTypes.ADD_DEPOSIT_IMPOSITION_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const depositDataRequest = () => ({
    type: actionTypes.DEPOSIT_DATA_IMPOSITION_REQUEST
});

const depositDataSuccess = (data) => ({
    type: actionTypes.DEPOSIT_DATA_IMPOSITION_SUCCESS,
    payload: {
        data
    }
});

const depositDataFailure = (error) => ({
    type: actionTypes.DEPOSIT_DATA_IMPOSITION_FAILURE,
    payload: {
        error
    }
});

const depositValidationRequest = () => ({
    type: actionTypes.DEPOSIT_VALIDATION_REQUEST,
});

const depositValidationSuccess = (response) => ({
    type: actionTypes.DEPOSIT_VALIDATION_SUCCESS,
    payload: {
        response
    }
});

const depositValidationError = (error) => ({
    type: actionTypes.DEPOSIT_VALIDATION_ERROR,
    payload: error
});

const addImpositionConfRequest = () => ({
    type: actionTypes.ADD_DEPOSIT_IMPOSITION_REQUEST
});

const addImpositionConfSuccess = (data) => ({
    type: actionTypes.ADD_DEPOSIT_IMPOSITION_SUCCESS,
    payload: {
        data
    }
});

const addImpositionConfFailure = (error) => ({
    type: actionTypes.ADD_DEPOSIT_IMPOSITION_FAILURE,
    payload: {
        error
    }
});

const updateRenewalPreference = (hasRenewal) => ({
    type: actionTypes.ADD_DEPOSIT_IMPOSITION_UPDATE_RENEWAL_PREFERENCE,
    payload: {
        hasRenewal
    }
});

const getDepositDetails = (depositId) => (dispatch, getState) => {
    const immDeposits = getState().deposits;
    const immDeposit = immDeposits.getIn(['byId', depositId]);
    const contractNumber = immDeposit.getIn(['contract', 'contractNumber']);
    const producto = immDeposit.getIn(['contract', 'product']);
    const requestData = {
        query: {
            "contrato": {
                "centro": {
                    "centro": API_CENTER,
                    "empresa": API_ENTERPRISE_NUMBER
                },
                "numerodecontrato": contractNumber,
                "producto": producto
            },
            "contratoMarco": {
                "centro": {
                    "centro": API_CENTER,
                    "empresa": API_ENTERPRISE_NUMBER
                },
                "numerodecontrato": contractNumber,
                "producto": producto
            },
            "empresa": API_ENTERPRISE_NUMBER,
            "moneda": 'EUR'
        }
    };

    dispatch(depositDataRequest());
    return APIPost({
        dispatch,
        endpoint: 'depositsImposition',
        params: requestData
    })
        .then((response) => dispatch(depositDataSuccess(response)))
        .catch((response) => {
            if (!!response.error) {
                dispatch(depositDataFailure(response.error));
            } else {
                throw response;
            }
        });
};

const addImpositionValidation = (depositId) => (dispatch, getState) => {

    const immImpositionState = getState().addImpositionDeposit;
    const valid = immImpositionState.getIn(['steps', FIRST_STEP, 'valid']);
    const visibleStep = immImpositionState.get('visibleStep');

    if(valid && visibleStep === 1) {
        const depositData = getState().depositsDetails.get('depositsData');
        const immDeposits = getState().deposits;
        const immDeposit = immDeposits.getIn(['byId', depositId]);
        const depositValue = immImpositionState.getIn(['steps', FIRST_STEP, 'depositValue']);
        const hasRenewal = immImpositionState.getIn(['steps', FIRST_STEP, 'hasRenewal']);
        const contractNumber = immDeposit.getIn(['contract', 'contractNumber']);
        const producto = immDeposit.getIn(['contract', 'product']);
        const currencyCode = immDeposit.getIn(['amount', 'currency']);

        const requestData = {
            query: {
                "canalComercializado": DEPOSIT_HIRE_CONFIRMATION_CHANNEL,//I don't know which data I have to put here
                "codPeriodoLiq": depositData.get('codPeriodoLiq'),
                "contrato": {
                    "centro": {
                        "centro": API_CENTER,
                        "empresa": API_ENTERPRISE_NUMBER
                    },
                    "numerodecontrato": contractNumber,
                    "producto": producto
                },
                "cotPeriodo": depositData.get('cotPeriodo'),
                "empresa": API_ENTERPRISE_NUMBER,
                "importe": depositValue,
                "indCapit": "N",//@harcoded
                "indRevto": hasRenewal,
                "moneda": currencyCode,
                "plazoPos": depositData.get('plazoPos'),
                "producto": {
                    "codigodeestandar": depositData.getIn(['producto', 'codigodeestandar']),
                    "subtipodeproducto": {
                        "subtipodeproducto": depositData.getIn(['producto', 'subtipodeproducto', 'subtipodeproducto']),
                        "tipodeproducto": {
                            "empresa": depositData.getIn(['producto','subtipodeproducto','tipodeproducto','empresa']),
                            "tipodeproducto": depositData.getIn(['producto','subtipodeproducto','tipodeproducto','tipodeproducto']),
                        }
                    }
                }
            }
        };

        dispatch(depositValidationRequest());
        return APIPost({
            dispatch,
            endpoint: 'depositsValidation',
            params: requestData
        })
            .then((response) => {
                dispatch(depositValidationSuccess(response));
                dispatch(setVisibleStep(2))})
            .catch((error) => {
                dispatch(depositValidationError(error));
                dispatch(setVisibleStep(1))})
    }
};

const addImpositionConf = (depositId) => (dispatch, getState) => {
    const depositData = getState().depositsDetails.get('depositsData');
    const immDeposits = getState().deposits;
    const immDeposit = immDeposits.getIn(['byId', depositId]);
    const contractNumber = immDeposit.getIn(['contract', 'contractNumber']).replace(/ /g,'');
    const producto = immDeposit.getIn(['contract', 'product']);
    const currencyCode = immDeposit.getIn(['amount', 'currency']);
    const immImpositionState = getState().addImpositionDeposit;
    const depositValue = immImpositionState.getIn(['steps', FIRST_STEP, 'depositValue']);
    const hasRenewal = immImpositionState.getIn(['steps', FIRST_STEP, 'hasRenewal']);

    const callback = (dispatch, getState, dataToken) => {
        const requestData = {
            query: {
                "codPeridoLiq": depositData.get('codPeriodoLiq'),
                "contrato": {
                    "numerodecontrato": contractNumber,
                    "producto": producto
                },
                "cotPeriodo": depositData.get('cotPeriodo'),
                "dataToken": dataToken,
                "importe": depositValue,
                "indcapit": "N",
                "indrevto": hasRenewal,
                "moneda": currencyCode,
                "plazoPos": depositData.get('plazoPos'),
                "producto": {
                    "codigodeestandar": depositData.getIn(['producto', 'codigodeestandar']),
                    "subtipodeproducto": {
                        "subtipodeproducto": depositData.getIn(['producto', 'subtipodeproducto', 'subtipodeproducto']),
                        "tipodeproducto": {
                            "tipodeproducto": depositData.getIn(['producto','subtipodeproducto','tipodeproducto','tipodeproducto'])
                        }
                    }
                },
                "salidaE": {
                    "aimpmar": immImpositionState.getIn(['addImpositionValidation', 'response', 'aimpmar']),
                    "aimporm": immImpositionState.getIn(['addImpositionValidation', 'response', 'aimporm']),
                    "aimpors": immImpositionState.getIn(['addImpositionValidation', 'response', 'aimpors']),
                    "arefconc": immImpositionState.getIn(['addImpositionValidation', 'response', 'arefconc']),
                    "areferen": immImpositionState.getIn(['addImpositionValidation', 'response', 'areferen']),
                    "arefernn": immImpositionState.getIn(['addImpositionValidation', 'response', 'arefernn']),
                    "aresdat1": immImpositionState.getIn(['addImpositionValidation', 'response', 'aresdat1']),
                    "aresdat2": immImpositionState.getIn(['addImpositionValidation', 'response', 'aresdat2']),
                    "aresdat3": immImpositionState.getIn(['addImpositionValidation', 'response', 'aresdat3']),
                    "aresdat4": immImpositionState.getIn(['addImpositionValidation', 'response', 'aresdat4']),
                    "aresdat5": immImpositionState.getIn(['addImpositionValidation', 'response', 'aresdat5']),
                    "aresdat6": immImpositionState.getIn(['addImpositionValidation', 'response', 'aresdat6']),
                    "aresdat7": immImpositionState.getIn(['addImpositionValidation', 'response', 'aresdat7']),
                    "avisopr": immImpositionState.getIn(['addImpositionValidation', 'response', 'avisopr']),
                    "b2CODCT": immImpositionState.getIn(['addImpositionValidation', 'response', 'b2CODCT']),
                    "b2EMPCT": immImpositionState.getIn(['addImpositionValidation', 'response', 'b2EMPCT']),
                    "caso": immImpositionState.getIn(['addImpositionValidation', 'response', 'caso']),
                    "codclcom": immImpositionState.getIn(['addImpositionValidation', 'response', 'codclcom']),
                    "codmocta": immImpositionState.getIn(['addImpositionValidation', 'response', 'codmocta']),
                    "codmons1": immImpositionState.getIn(['addImpositionValidation', 'response', 'codmons1']),
                    "codmons2": immImpositionState.getIn(['addImpositionValidation', 'response', 'codmons2']),
                    "codmonsw": immImpositionState.getIn(['addImpositionValidation', 'response', 'codmonsw']),
                    "codperiv": immImpositionState.getIn(['addImpositionValidation', 'response', 'codperiv']),
                    "codpers": immImpositionState.getIn(['addImpositionValidation', 'response', 'codpers']),
                    "coestre1": immImpositionState.getIn(['addImpositionValidation', 'response', 'coestre1']),
                    "coestref": immImpositionState.getIn(['addImpositionValidation', 'response', 'coestref']),
                    "coperiod": immImpositionState.getIn(['addImpositionValidation', 'response', 'coperiod']),
                    "coperliq": immImpositionState.getIn(['addImpositionValidation', 'response', 'coperliq']),
                    "cotperi1": immImpositionState.getIn(['addImpositionValidation', 'response', 'cotperi1']),
                    "cotperio": immImpositionState.getIn(['addImpositionValidation', 'response', 'cotperio']),
                    "desccom2": immImpositionState.getIn(['addImpositionValidation', 'response', 'desccom2']),
                    "descod": immImpositionState.getIn(['addImpositionValidation', 'response', 'descod']),
                    "desestan": immImpositionState.getIn(['addImpositionValidation', 'response', 'desestan']),
                    "diamaxpe": immImpositionState.getIn(['addImpositionValidation', 'response', 'diamaxpe']),
                    "digitoc1": immImpositionState.getIn(['addImpositionValidation', 'response', 'digitoc1']),
                    "digitoc2": immImpositionState.getIn(['addImpositionValidation', 'response', 'digitoc2']),
                    "digitoc3": immImpositionState.getIn(['addImpositionValidation', 'response', 'digitoc3']),
                    "digitoc4": immImpositionState.getIn(['addImpositionValidation', 'response', 'digitoc4']),
                    "doclin1": immImpositionState.getIn(['addImpositionValidation', 'response', 'doclin1']),
                    "doclin10": immImpositionState.getIn(['addImpositionValidation', 'response', 'doclin10']),
                    "doclin11": immImpositionState.getIn(['addImpositionValidation', 'response', 'doclin11']),
                    "doclin12": immImpositionState.getIn(['addImpositionValidation', 'response', 'doclin12']),
                    "doclin13": immImpositionState.getIn(['addImpositionValidation', 'response', 'doclin13']),
                    "doclin14": immImpositionState.getIn(['addImpositionValidation', 'response', 'doclin14']),
                    "doclin15": immImpositionState.getIn(['addImpositionValidation', 'response', 'doclin15']),
                    "doclin2": immImpositionState.getIn(['addImpositionValidation', 'response', 'doclin2']),
                    "doclin3": immImpositionState.getIn(['addImpositionValidation', 'response', 'doclin3']),
                    "doclin4": immImpositionState.getIn(['addImpositionValidation', 'response', 'doclin4']),
                    "doclin5": immImpositionState.getIn(['addImpositionValidation', 'response', 'doclin5']),
                    "doclin6": immImpositionState.getIn(['addImpositionValidation', 'response', 'doclin6']),
                    "doclin7": immImpositionState.getIn(['addImpositionValidation', 'response', 'doclin7']),
                    "doclin8": immImpositionState.getIn(['addImpositionValidation', 'response', 'doclin8']),
                    "doclin9": immImpositionState.getIn(['addImpositionValidation', 'response', 'doclin9']),
                    "fecini": immImpositionState.getIn(['addImpositionValidation', 'response', 'fecini']),
                    "fecini1": immImpositionState.getIn(['addImpositionValidation', 'response', 'fecini1']),
                    "fecval1": immImpositionState.getIn(['addImpositionValidation', 'response', 'fecval1']),
                    "fecval11": immImpositionState.getIn(['addImpositionValidation', 'response', 'fecval11']),
                    "fecval2": immImpositionState.getIn(['addImpositionValidation', 'response', 'fecval2']),
                    "fecval22": immImpositionState.getIn(['addImpositionValidation', 'response', 'fecval22']),
                    "fecvenc2": immImpositionState.getIn(['addImpositionValidation', 'response', 'fecvenc2']),
                    "fecvenci": immImpositionState.getIn(['addImpositionValidation', 'response', 'fecvenci']),
                    "idcent": immImpositionState.getIn(['addImpositionValidation', 'response', 'idcent']),
                    "idcent1": immImpositionState.getIn(['addImpositionValidation', 'response', 'idcent1']),
                    "idcent2": immImpositionState.getIn(['addImpositionValidation', 'response', 'idcent2']),
                    "idcentca": immImpositionState.getIn(['addImpositionValidation', 'response', 'idcentca']),
                    "idcesta": immImpositionState.getIn(['addImpositionValidation', 'response', 'idcesta']),
                    "idcontc2": immImpositionState.getIn(['addImpositionValidation', 'response', 'idcontc2']),
                    "idcontca": immImpositionState.getIn(['addImpositionValidation', 'response', 'idcontca']),
                    "idcontcc": immImpositionState.getIn(['addImpositionValidation', 'response', 'idcontcc']),
                    "idcontr": immImpositionState.getIn(['addImpositionValidation', 'response', 'idcontr']),
                    "idcontr1": immImpositionState.getIn(['addImpositionValidation', 'response', 'idcontr1']),
                    "idempr": immImpositionState.getIn(['addImpositionValidation', 'response', 'idempr']),
                    "idempr01": immImpositionState.getIn(['addImpositionValidation', 'response', 'idempr01']),
                    "idempr2": immImpositionState.getIn(['addImpositionValidation', 'response', 'idempr2']),
                    "idemprca": immImpositionState.getIn(['addImpositionValidation', 'response', 'idemprca']),
                    "idemprct": immImpositionState.getIn(['addImpositionValidation', 'response', 'idemprct']),
                    "idprod": immImpositionState.getIn(['addImpositionValidation', 'response', 'idprod']),
                    "idprod1": immImpositionState.getIn(['addImpositionValidation', 'response', 'idprod1']),
                    "idprodca": immImpositionState.getIn(['addImpositionValidation', 'response', 'idprodca']),
                    "idscontr": immImpositionState.getIn(['addImpositionValidation', 'response', 'idscontr']),
                    "idscontt": immImpositionState.getIn(['addImpositionValidation', 'response', 'idscontt']),
                    "idsprod": immImpositionState.getIn(['addImpositionValidation', 'response', 'idsprod']),
                    "idsprod2": immImpositionState.getIn(['addImpositionValidation', 'response', 'idsprod2']),
                    "imcoimpo": immImpositionState.getIn(['addImpositionValidation', 'response', 'imcoimpo']),
                    "impcipf": immImpositionState.getIn(['addImpositionValidation', 'response', 'impcipf']),
                    "impcta2": immImpositionState.getIn(['addImpositionValidation', 'response', 'impcta2']),
                    "impctvl": immImpositionState.getIn(['addImpositionValidation', 'response', 'impctvl']),
                    "impopts": immImpositionState.getIn(['addImpositionValidation', 'response', 'impopts']),
                    "impordeb": immImpositionState.getIn(['addImpositionValidation', 'response', 'impordeb']),
                    "imporhab": immImpositionState.getIn(['addImpositionValidation', 'response', 'imporhab']),
                    "importen": immImpositionState.getIn(['addImpositionValidation', 'response', 'importen']),
                    "incaldia": immImpositionState.getIn(['addImpositionValidation', 'response', 'incaldia']),
                    "indaplic": immImpositionState.getIn(['addImpositionValidation', 'response', 'indaplic']),
                    "indcapit": immImpositionState.getIn(['addImpositionValidation', 'response', 'indcapit']),
                    "indcondi": immImpositionState.getIn(['addImpositionValidation', 'response', 'indcondi']),
                    "indpend": immImpositionState.getIn(['addImpositionValidation', 'response', 'indpend']),
                    "indprec": immImpositionState.getIn(['addImpositionValidation', 'response', 'indprec']),
                    "indresi": immImpositionState.getIn(['addImpositionValidation', 'response', 'indresi']),
                    "indrevto": immImpositionState.getIn(['addImpositionValidation', 'response', 'indrevto']),
                    "listaRegistro": {
                        "lista": [
                            {
                                "atasa": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','atasa']),
                                "atasafin": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','atasafin']),
                                "coconcli": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','coconcli']),
                                "copercon": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','copercon']),
                                "coredond": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','coredond']),
                                "cotraapl": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','cotraapl']),
                                "cotrefer": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','cotrefer']),
                                "descripe": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','descripe']),
                                "dispon1": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','dispon1']),
                                "fecdesde": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','fecdesde']),
                                "fechasta": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','fechasta']),
                                "fecomval": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','fecomval']),
                                "fefinval": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','fefinval']),
                                "fetasref": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','fetasref']),
                                "imminfr": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','imminfr']),
                                "intactua": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','intactua']),
                                "plazocl2": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','plazocl2']),
                                "poimfran": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','poimfran']),
                                "tafranq": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','tafranq']),
                                "tasa": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','tasa']),
                                "tasa1": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','tasa1']),
                                "tasadif": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','tasadif']),
                                "tasamaxi": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','tasamaxi']),
                                "tasamini": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','tasamini']),
                                "tasaref": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','tasaref']),
                                "traplic": immImpositionState.getIn(['addImpositionValidation', 'response','listaAltaImposicionValidacion','lista[0]','traplic'])
                            }
                        ]
                    },
                    "marca": immImpositionState.getIn(['addImpositionValidation', 'response','marca']),
                    "nomlogo": immImpositionState.getIn(['addImpositionValidation', 'response','nomlogo']),
                    "nroemp": immImpositionState.getIn(['addImpositionValidation', 'response','nroemp']),
                    "nudivfij": immImpositionState.getIn(['addImpositionValidation', 'response','nudivfij']),
                    "numcta": immImpositionState.getIn(['addImpositionValidation', 'response','numcta']),
                    "plazocas": immImpositionState.getIn(['addImpositionValidation', 'response','plazocas']),
                    "plazoclq": immImpositionState.getIn(['addImpositionValidation', 'response','plazoclq']),
                    "refcoron": immImpositionState.getIn(['addImpositionValidation', 'response','refcoron']),
                    "subgrc2": immImpositionState.getIn(['addImpositionValidation', 'response','subgrc2']),
                    "subgrca": immImpositionState.getIn(['addImpositionValidation', 'response','subgrca']),
                    "taf": immImpositionState.getIn(['addImpositionValidation', 'response','taf']),
                    "tipcur": immImpositionState.getIn(['addImpositionValidation', 'response','tipcur']),
                    "tipopers": immImpositionState.getIn(['addImpositionValidation', 'response','tipopers']),
                    "zcodper": immImpositionState.getIn(['addImpositionValidation', 'response','zcodper']),
                    "ztipoper": immImpositionState.getIn(['addImpositionValidation', 'response','ztipoper'])
                }
            }
        };
        dispatch(addImpositionConfRequest());
        return APIPost({
            dispatch,
            endpoint: 'addImpositionConf',
            params: requestData
        })
            .then((response) => dispatch(addImpositionConfSuccess(response)))
            .catch((response) => dispatch(addImpositionConfFailure(response)));
    };
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
};

const validateStep = (depositId) => (dispatch, getState) => {
    const depositsData = getState().depositsDetails;

    dispatch(validateUIStep(depositsData));
    dispatch(addImpositionValidation(depositId));
};

module.exports = {
    reset,
    setWillCancel,
    setVisibleStep,
    setCurrentDepositImposition,
    validateStep,
    addImpositionConf,
    addImpositionValidation,
    getDepositDetails,
    updateRenewalPreference
}
